import { gql } from '@apollo/client';

export const fetchPricingHistoryForEntitlement = gql`
  query fetchPricingHistoryForEntitlement(
    $id: String
    $filters: EntitlementDetailsFilters
    $searchOptions: ConnectionSearchOptions
  ) {
    entitlementDetails(id: $id, filters: $filters) {
      id
      pricingPlanHistory(searchOptions: $searchOptions) {
        totalCount
        nodes {
          id
          invoiceNumber
          status
          billingGroupId
          sourceSystem
          totalDiscount
          total
          taxes
          subtotal
          taxes
          taxesPaymentCurrency
          itemsTotal
          paymentCurrency
          paidDate
          lineItems {
            id
            edition
            entitlementId
            pricingPlanId
            entitlementNumber
            cloudSiteHostname
            amount
            total
            subtotal
            description
            platform
            productKey
            startDate
            invoiceLineItemId
            endDate
            discounts {
              amount
              type
              percent
              reason
              reasonCode
            }
            quantity
            pricingPlan {
              id
              pricingPlanType
              description
              type
              amount
              status
              billingFrequency
              currency
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
